import { useEffect, useState } from 'react';
import './FormsContent.css';
import { getIntakeForms } from '../../utilities/api/allForms';
import FormsItem from '../../components/FormsItem/FormsItem';
import FormsFilter from '../../components/FormsFilter/FormsFilter';
import { getServices } from '../../utilities/api/services';
import { dateSort, projNumSort } from '../../utilities/services/sortConditionally';
import SearchBar from '../../components/SearchBar/SearchBar';

export default function FormsContent({ user, isMobile, formsPreferences, toggleNotifications }) {

  const [loading, setLoading] = useState(false)
  const [forms, setForms] = useState([])
  const [services, setServices] = useState([])
  const [servicesObjectList, setServicesObjectList] = useState([])
  const [sortOrder, setSortOrder] = useState('desc')
  const [sortHeader, setSortHeader] = useState('createdAt')

  const getForms = async () => {
    setLoading(true)
    try {
      const allForms = await getIntakeForms()
      setForms(allForms.sort((a, b) => a[sortHeader] < b[sortHeader] ? 1 : -1))
    } catch (error) {
      console.log(error)
    }
    setLoading(false)
  }

  const updateForms = (updatedForms) => {
    let sortedForms = [...updatedForms];
    if (sortHeader === 'projectNumber') {
        sortedForms = projNumSort(sortOrder, sortHeader, sortedForms);
    } else if (['submissionDate', 'approvalDate'].includes(sortHeader)) {
        sortedForms = dateSort(sortOrder, sortHeader, sortedForms);
    } else {
        sortedForms.sort((a, b) => {
            if (sortOrder === 'asc') {
                return ((typeof(a[sortHeader])==='string' ? a[sortHeader].toLowerCase() : a[sortHeader]) > (typeof(b[sortHeader])==='string' ? b[sortHeader].toLowerCase() : b[sortHeader])) ? 1 : -1
            } else {
                return ((typeof(a[sortHeader])==='string' ? a[sortHeader].toLowerCase() : a[sortHeader]) < (typeof(b[sortHeader])==='string' ? b[sortHeader].toLowerCase() : b[sortHeader])) ? 1 : -1
            }
        });
    }
    setForms(sortedForms);
  };

  const getAllServices = async () => {
    try {
      const services = await getServices()
      setServicesObjectList(services)
      const serviceCodes = services.map(service => service.code)
      setServices(serviceCodes)
    } catch (error) {
      console.log(error)
    }
  }

  // console.log(forms)

  const handleTableHeaderClick = (evt) => {
    const header = evt.target.id;
    const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    setSortHeader(header);
    setSortOrder(newSortOrder);

    let sortedForms = [...forms];
    if (header === 'projectNumber') {
        sortedForms = projNumSort(newSortOrder, header, sortedForms);
    } else if (['submissionDate', 'approvalDate'].includes(header)) {
        sortedForms = dateSort(newSortOrder, header, sortedForms);
    } else {
        sortedForms.sort((a, b) => {
            if (newSortOrder === 'asc') {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            } else {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            }
        });
    }
    setForms(sortedForms);
  }

  useEffect(() => {
    if (user.userType === 'admin' || user.userType === 'manager') {
      getForms()
    }
    getAllServices()
    // eslint-disable-next-line
  },[])

  return (
    <div className='FormsContent'>
      <div className='formsHeadingContainer'>
        <div className='section1'>
          <div className='title'>
            Intake Forms
          </div>
          <SearchBar user={user} section={'forms'} updateContent={updateForms} />
        </div>
      </div>
      {loading ?
      <div className='loading'>
        <div className="spinner-border" role="status"></div>
      </div>
      :
      <div className='formsMainSection'>
        <div className='header'>
          <div className='title'>
            Form List
          </div>
          <div className='filterContainer'>
            <FormsFilter updateForms={updateForms} services={services} isMobile={isMobile} sortHeader={sortHeader} />
          </div>
        </div>
        <div className='formsTable'>
          <table className=''>
            { formsPreferences &&
            <>
            <thead>
              <tr>
                { !formsPreferences.includes('projectNumber') &&
                <th id='projectNumber' onClick={handleTableHeaderClick} className='projectNumber' title='Click to sort by project number'>
                  <div className='tableHeaderWithArrow'><div>Project Number&nbsp;&nbsp;</div>
                  { sortHeader==='projectNumber'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !formsPreferences.includes('title') &&
                <th id='titleOfInvention' className='titleOfInvention'>Title</th>
                }
                { !formsPreferences.includes('service') &&
                <th id='service' onClick={handleTableHeaderClick} className='service' title='Click to sort by service'>
                  <div className='tableHeaderWithArrow'><div>Service&nbsp;&nbsp;</div>
                  { sortHeader==='service'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !formsPreferences.includes('companyName') &&
                <th id='companyName' onClick={handleTableHeaderClick} title='Click to sort by client'>
                  <div className='tableHeaderWithArrow'><div>Client&nbsp;&nbsp;</div>
                  { sortHeader==='companyName'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !formsPreferences.includes('createdAt') &&
                <th id='createdAt' onClick={handleTableHeaderClick} className='createdAt' title='Click to sort by creation date'>
                  <div className='tableHeaderWithArrow'><div>Creation&nbsp;&nbsp;</div>
                  { sortHeader==='createdAt'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !formsPreferences.includes('updatedAt') &&
                <th id='updatedAt' onClick={handleTableHeaderClick} className='updatedAt' title='Click to sort by last update date'>
                  <div className='tableHeaderWithArrow'><div>Last Update&nbsp;&nbsp;</div>
                  { sortHeader==='updatedAt'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !formsPreferences.includes('status') &&
                <th id='status' onClick={handleTableHeaderClick} title='Click to sort by status'>
                  <div className='tableHeaderWithArrow'><div>Status&nbsp;&nbsp;</div>
                  { sortHeader==='status'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !formsPreferences.includes('submissionDate') &&
                <th id='submissionDate' onClick={handleTableHeaderClick} className='submissionDate' title='Click to sort by submission date'>
                  <div className='tableHeaderWithArrow'><div>Submission Date&nbsp;&nbsp;</div>
                  { sortHeader==='submissionDate'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                { !formsPreferences.includes('approvalDate') &&
                <th id='approvalDate' onClick={handleTableHeaderClick} className='approvalDate' title='Click to sort by last approval date'>
                  <div className='tableHeaderWithArrow'><div>Approval Date&nbsp;&nbsp;</div>
                  { sortHeader==='approvalDate'?
                      <>
                      {sortOrder==='asc' ?
                      <div>
                          <div className='sortIndicatorActive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                      : 
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorActive'>&#9660;</div>
                      </div>
                      }
                      </>
                      :
                      <div>
                          <div className='sortIndicatorInactive'>&#9650;</div>
                          <div className='sortIndicatorInactive'>&#9660;</div>
                      </div>
                  }
                  </div>
                </th>
                }
                <th id='actions' className='actions'>Actions</th>
              </tr>
            </thead>
            <tbody>
              { forms.length === 0 ?
              <tr>
                <td colSpan='12' className='noForms text-center'>No Forms Found</td>
              </tr>
              :
              <>
              {forms.map(form => (
                <FormsItem user={user} key={form._id} formItem={form} services={servicesObjectList} isMobile={isMobile} getForms={getForms} toggleNotifications={toggleNotifications} formsPreferences={formsPreferences} />
              ))}
              </>
              }
            </tbody>
            </>
          }
          </table>
        </div>
        <div className='footer'>
          <div>
            page count
          </div>
          <div>
            toggle
          </div>
        </div>
      </div>
      }
    </div>
  )
}
